import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"
import { convertDotToCommaZero } from "../../../app/helpers/TextHelper.js"
export const CvlDocument = ({ data, name }) => {
  const rows = 8
  const { t } = useTranslation()

  const getValue = (index) => data?.cvl[index] ?? "-"

  return (
    <table className="w-full border-padding-0 border-dark bg-gray my-1 font-size-lg">
      <thead className={"text-wrap"}>
        <tr>
          <th className={"border-padding-0 border-right-0 border-dark p-0"} colSpan={"8"}>
            {name}
          </th>
          <th className={"border-padding-0 border-left-0 border-dark p-0"} colSpan={"8"}>
            <div>{t(`label_average`, { data: `: ${convertDotToCommaZero(data?.average)} %` })}</div>
          </th>
        </tr>
      </thead>
      <thead className={"text-wrap"}>
        <tr>
          <th className={"border-padding-0 border-dark p-0"} colSpan={"8"}>
            <div className={"mr-2 font-weight-bold"}>
              <strong>{t("label_example_point")}:</strong>{" "}
              {data?.total_point ? data?.total_point : "-"}
            </div>
          </th>
          <th className={"border-padding-0 border-dark p-0"} colSpan={"8"}>
            <div className={"mr-2 font-weight-bold"}>
              <strong>{t("label_example_point")}:</strong> 100{" "}
              <span className="font-weight-bold">{t("label_plant_family")}</span>
            </div>
          </th>
        </tr>
      </thead>
      <thead className={"text-center"}>
        <tr>
          {[...Array(rows)].map((_, i) => (
            <Fragment key={i}>
              <th className="border-padding-0 border-dark p-0">No.</th>
              <th className="border-padding-0 border-dark p-0">CVL/TS</th>
            </Fragment>
          ))}
        </tr>
      </thead>
      <tbody className={"text-center"}>
        <tr>
          {[...Array(rows)].map((_, i) => (
            <Fragment key={i}>
              <td className="border-padding-0 border-dark font-weight-bolder p-0">{i * 2 + 1}.</td>
              <td className="border-padding-0 border-dark p-0">{getValue(i * 2)}</td>
            </Fragment>
          ))}
        </tr>
        <tr>
          {[...Array(rows)].map((_, i) => (
            <Fragment key={i}>
              <td className="border-padding-0 border-dark font-weight-bolder p-0">{i * 2 + 2}.</td>
              <td className="border-padding-0 border-dark p-0">{getValue(i * 2 + 1)}</td>
            </Fragment>
          ))}
        </tr>
      </tbody>
    </table>
  )
}
